import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { QueryKeys } from '@/constants/queryKeys';

export type LeaderboardData = {
  coldkey: string;
  emission: number;
  incentive: number;
  neuron_uid: number;
  pruning_score: number;
  rank: number;
  stake: number;
  updated_at: string;
  position: number;
};

const fetchLeaderboardData = async (): Promise<LeaderboardData[]> => {
  try {
    const { data } = await axios.get('/api/leaderboard');
    return data.map((item: LeaderboardData, index: number) => ({
      ...item,
      position: index + 1,
    }));
  } catch (error) {
    console.error('Error fetching leaderboard data:', error);
    throw error;
  }
};

export const useLeaderboard = (options = {}) => {
  return useQuery({
    queryKey: [QueryKeys.LEADERBOARD],
    queryFn: fetchLeaderboardData,
    refetchInterval: 1000 * 60 * 10,
    ...options,
  });
};
